import React from "react";
import InputForm from "../../common/InputForm";
import ModalToChange from "../../Layout/ModalToChange";
import { SelectForm, CheckBoxInput } from "../../common/Buttons";
import SelectBoxes from "../../common/SelectBoxes";

class PickupEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      id: 0,
      code: "",
      company: "",
      contact_person: "",
      address: "",
      address2: "",
      city: "",
      country_id: "",
      postal_code: "",
      phone: "",
      work_time_to: "",
      pickup_time_from: "",
      email: "",
      active: false,
      comment: "",
      countries: [],
      action: "new",
      label_sizes: [],
      auto_shipment_email: false,
      technorama: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.action === "new" && this.state.action === "edit") {
      this.setState({
        code: "",
        company: "",
        contact_person: "",
        address: "",
        address2: "",
        city: "",
        country_id: "",
        postal_code: "",
        phone: "",
        work_time_to: "",
        pickup_time_from: "",
        email: "",
        active: false,
        comment: "",
        action: "new",
        label_sizes: [],
        auto_shipment_email: false,
        technorama: false,
      });
      this.removeErrors(nextProps.errors);
    } else if (
      nextProps.action === "edit" &&
      nextProps.objectData.id !== this.state.id
    ) {
      let item = nextProps.objectData;
      this.setState({
        id: item.id || 0,
        code: item.code || "",
        company: item.company || "",
        contact_person: item.contact_person || "",
        address: item.address || "",
        address2: item.address2 || "",
        city: item.city || "",
        country_id: item.country_id || "",
        postal_code: item.postal_code || "",
        phone: item.phone || "",
        work_time_to: item.work_time_to || "",
        pickup_time_from: item.pickup_time_from || "",
        email: item.email || "",
        active: item.active || false,
        comment: item.comment || "",
        label_sizes: item.label_sizes || [],
        auto_shipment_email: item.auto_shipment_email || false,
        technorama: item.technorama || false,
        action: "edit",
      });
      this.removeErrors(nextProps.errors);
    }
    if (nextProps.countries) {
      let countries = [];
      nextProps.countries.forEach((item) => {
        return countries.push({
          label: item.name,
          value: item.id,
        });
      });
      this.setState({
        countries,
      });
    }
  }

  removeErrors = (errors) => {
    if (Object.keys(errors).length > 0) {
      this.props.clearErrors();
    }
  };

  handleChange = (e, select) => {
    if (select) {
      this.setState({
        [select]: e,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const variables = {
      pickup_address: {
        code: this.state.code,
        company: this.state.company,
        contact_person: this.state.contact_person,
        address: this.state.address,
        address2: this.state.address2,
        city: this.state.city,
        country_id: this.state.country_id,
        postal_code: this.state.postal_code,
        phone: this.state.phone,
        work_time_to: this.state.work_time_to,
        pickup_time_from: this.state.pickup_time_from,
        email: this.state.email,
        active: this.state.active,
        comment: this.state.comment,
        label_sizes: this.state.label_sizes,
        auto_shipment_email: this.state.auto_shipment_email,
        technorama: this.state.technorama,
      },
    };
    if (this.props.action == "new") {
      this.props.postPickupAddress(variables);
    } else if (this.props.action === "edit") {
      this.props.updatePickupAddress(this.state.id, variables);
    }
  };

  render() {
    const activeOptions = [
      { label: "Active", value: true },
      { label: "Inactive", value: false },
    ];
    return (
      <ModalToChange
        handleSave={(e) => this.onSubmit(e)}
        status="tableEdit"
        text={this.props.action === "new" ? "Create new" : "Edit"}
        buttonText={this.props.action === "new" ? "Create" : "Update"}
      >
        <InputForm
          type="text"
          placeholder="Code"
          name="code"
          value={this.state.code}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Company"
          name="company"
          value={this.state.company}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Contact person"
          name="contact_person"
          value={this.state.contact_person}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Adress"
          name="address"
          value={this.state.address}
          error={
            this.props.errors.address &&
            this.props.errors.address.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Second address"
          name="address2"
          value={this.state.address2}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="City"
          name="city"
          value={this.state.city}
          error={
            this.props.errors.city &&
            this.props.errors.city.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <SelectForm
          placeholder={"Country"}
          selector="country_id"
          value={this.state.country_id}
          options={this.state.countries}
          onChange={(e) => this.handleChange(e, "country_id")}
          error={
            this.props.errors.country_id &&
            this.props.errors.country_id.map((item) => `${item} `)
          }
        />

        <InputForm
          type="text"
          placeholder="Postal code"
          name="postal_code"
          value={this.state.postal_code}
          error={
            this.props.errors.postal_code &&
            this.props.errors.postal_code.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Phone number"
          name="phone"
          value={this.state.phone}
          error={
            this.props.errors.phone &&
            this.props.errors.phone.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Work time from:"
          name="pickup_time_from"
          value={this.state.pickup_time_from}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Work time to:"
          name="work_time_to"
          value={this.state.work_time_to}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="email"
          placeholder="E.mail"
          name="email"
          value={this.state.email}
          error={
            this.props.errors.email &&
            this.props.errors.email.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />

        <SelectForm
          placeholder={"Active ?"}
          selector="active"
          value={this.state.active}
          onChange={(e) => this.handleChange(e, "active")}
          options={activeOptions}
        />

        <InputForm
          type="text"
          placeholder="Comments"
          name="comment"
          value={this.state.comment}
          onChange={(e) => this.handleChange(e)}
        />
        <SelectBoxes
          label="Label size"
          options={[
            {
              value: "A4",
              label: "A4",
            },
            {
              label: "A5",
              value: "A5",
            },
            {
              value: "A6",
              label: "A6",
            },
          ]}
          value={this.state.label_sizes}
          onChange={(label_sizes) => this.setState({ label_sizes })}
        />

        <CheckBoxInput
          choised="auto_shipment_email"
          color="#f7951e"
          text="Auto shipment email"
          checked={this.state.auto_shipment_email}
          onChange={(e) =>
            this.handleChange({
              target: { name: "auto_shipment_email", value: e.target.checked },
            })
          }
        />

        <CheckBoxInput
          text="Technorama"
          checked={this.state.technorama}
          onChange={(e) =>
            this.handleChange({
              target: { name: "technorama", value: e.target.checked },
            })
          }
        />
      </ModalToChange>
    );
  }
}

export default PickupEditModal;
